import { css } from '@emotion/react';

import { Sizes, Spacing } from 'chatie-design-system';
import { Honor, Icon } from 'chatie-design-system/icon';

import { MarketItemType } from '../../constants';
import { IMarketItemUserNicknameResource, ISimpleUser } from '../../model';
import { useUserMarketItemInventory } from '../../utils/hook';

const nicknameCSS = (color?: string) => css`
  ${color &&
  css`
    color: ${color};
  `}

  margin-right: ${Spacing.xxxsmall}px;
`;

type Props = {
  /**
   * 명예 작가 아이콘 사이즈
   */
  size?: Sizes;
  decoration?: IMarketItemUserNicknameResource;
} & Pick<ISimpleUser, 'id' | 'nickname' | 'hasHonorPartnership'>;

const Nickname = ({
  id,
  nickname,
  hasHonorPartnership,
  size = Sizes.xsmall,
}: Props) => {
  const { data, getDecoration } = useUserMarketItemInventory(id);
  const nicknameDeco = getDecoration(data, MarketItemType.userNickname);

  return (
    <>
      <span css={nicknameCSS(nicknameDeco?.object.textColor)}>{nickname}</span>
      {hasHonorPartnership && <Icon icon={Honor} size={size} />}
    </>
  );
};

export default Nickname;
